/*
* Copyright (c) 2023 Eugenio Espinoza
*/

import React from 'react';
import './PageHero.css';

function PageHero({ eyebrow, title, italic, lede, meta }) {
  return (
    <section className="mt-pageHero">
      <div className="mt-container mt-pageHero__inner">
        {meta && (
          <div className="mt-pageHero__meta">
            {meta.map((m, i) => (
              <span key={i}>{m}</span>
            ))}
          </div>
        )}

        {eyebrow && <span className="mt-eyebrow mt-pageHero__eyebrow">{eyebrow}</span>}

        <h1 className="mt-pageHero__title">
          {title}
          {italic && <em> {italic}</em>}
        </h1>

        {lede && <p className="mt-pageHero__lede">{lede}</p>}

        <div className="mt-pageHero__rule" aria-hidden="true" />
      </div>
    </section>
  );
}

export default PageHero;
